import { Formik } from 'formik';
import { useCallback, useState } from 'react';
import useSWR from 'swr';

import { FormWithPrompt } from '@shared/components/FormWithPrompt';
import { SERVICES } from '@shared/constants/apiConfig';
import { Wrapper } from '@styles/CommonStyles';

import { PhoenixGridHeader } from '../../Tools/LenderUtility/shared/PhoenixGridHeader';
import { initialQueueConfiguration, queueConfigurationValidationSchema } from './constants';
import { QueueConfigurationForm } from './QueueConfigurationForm';
import { requestCreateQueueConfiguration, requestUpdateQueueConfiguration } from './requests';
import { IQueueConfiguration } from './types';

const QueueConfiguration = () => {
  const [initialState, setInitialState] = useState<IQueueConfiguration>(initialQueueConfiguration);
  const [isEditMode, setIsEditMode] = useState(true);
  const [queueGroup, setQueueGroup] = useState<string>('');
  const [queueSubGroup, setQueueSubGroup] = useState('');

  const { data: queueConfigurationFetched, mutate } = useSWR<IQueueConfiguration>(
    queueGroup &&
      queueSubGroup &&
      isEditMode &&
      `${SERVICES.CONFIGURATION}/queue-configurations/groups/${queueGroup}/subgroups/${queueSubGroup}`,
  );

  const handleSubmit = useCallback(
    async (data: IQueueConfiguration) => {
      isEditMode
        ? await requestUpdateQueueConfiguration(data)
        : await requestCreateQueueConfiguration(data).then(() => setIsEditMode(true));
      mutate();
    },
    [isEditMode]
  );

  return (
    <Wrapper>
      <PhoenixGridHeader title="Queue configuration" />

      <Formik
        enableReinitialize
        initialValues={initialState as IQueueConfiguration}
        validationSchema={queueConfigurationValidationSchema}
        onSubmit={handleSubmit}
      >
        {(props) => (
          <FormWithPrompt>
            <QueueConfigurationForm
              setInitialState={setInitialState}
              setIsEditMode={setIsEditMode}
              isEditMode={isEditMode}
              queueGroup={queueGroup}
              setQueueGroup={setQueueGroup}
              queueSubGroup={queueSubGroup}
              setQueueSubGroup={setQueueSubGroup}
              queueConfigurationFetched={queueConfigurationFetched}
              {...props}
            />
          </FormWithPrompt>
        )}
      </Formik>
    </Wrapper>
  );
};

export default QueueConfiguration;
